import React, { useState, useEffect } from 'react';
import useGlobalState from '../../hooks/use-global-state';
import {
  selectFrogsWithSubmissionCount,
  setActiveFrogType,
} from '../../modules/app-duck';
import { colors } from '../../modules/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { H3, P, pixelToRem } from '../ui';
import FrogList from '../frog-list';
export default function SpeciesContent() {
  const { state, dispatch } = useGlobalState();
  const frogs = selectFrogsWithSubmissionCount(state);
  const [searchValue, setSearchValue] = useState('');
  useEffect(() => {
    setSearchValue('');
  }, [state.tab]);
  const searchFilteredFrogs = frogs.filter(
    x =>
      searchValue === '' ||
      x.common_name.toLowerCase().includes(searchValue.toLowerCase()) ||
      x.latin_name.toLowerCase().includes(searchValue.toLowerCase())
  );
  if (frogs.length === 0 && state.submissionsFetched === false) {
    return (
      <div
        css={{
          background: colors.darkBlue,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center',
        }}
      >
        <P css={{ padding: 10, textAlign: 'center', color: 'white' }}>
          Loading...
        </P>
      </div>
    );
  }
  return (
    <div
      css={{
        background: colors.darkBlue,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      <div css={{ padding: '10px 15px' }}>
        <div css={{ position: 'relative' }}>
          <input
            css={{
              width: '100%',
              borderRadius: '4px',
              height: '38px',
              lineHeight: '38px',
              border: 'none',
              padding: '0 45px 0 10px',
              '::placeholder': {
                fontSize: pixelToRem(16),
                fontStyle: 'italic',
              },
            }}
            onChange={e => setSearchValue(e.target.value)}
            value={searchValue}
            placeholder={'Search for species'}
          />

          {searchValue && (
            <FontAwesomeIcon
              onClick={() => {
                dispatch(setActiveFrogType());
                setSearchValue('');
              }}
              css={{
                position: 'absolute',
                right: 35,
                margin: 'auto',
                top: 0,
                bottom: 0,
                cursor: 'pointer',
              }}
              icon={faTimes}
              style={{ color: colors.blue }}
            />
          )}
          <FontAwesomeIcon
            css={{
              position: 'absolute',
              right: 10,
              margin: 'auto',
              top: 0,
              bottom: 0,
            }}
            icon={faSearch}
            style={{ color: colors.blue }}
          />
        </div>
      </div>

      {searchFilteredFrogs.length > 0 ? (
        <FrogList frogs={searchFilteredFrogs} />
      ) : (
        <H3 css={{ paddingLeft: 15, color: 'white' }}>No frogs found.</H3>
      )}
    </div>
  );
}
